<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"  >
  <p style="font-size: 20px; color: white" *ngIf="!showSSOMEssage">{{'registration.saving' | translate}}</p>
  <p style="font-size: 20px; color: white" *ngIf="showSSOMEssage">{{'registration.connectingTalentsoft' | translate}}</p>
</ngx-spinner>

      <!--NLMK Formulaire-->
      <ng-container *ngIf="show_nlk_form">
        <div class="container">
          <div class="col-lg-12">
            <div class="jumbotron">
              <div class="title">
                <h2 class="display-4 font-weight-bold" style="text-align: center">{{forms.title}}</h2></div>
              <div class="row justify-content-center custom-line">
                <div class="col-lg-6 col-md-10 col-sm-9">
                  <h2 class="display-4 font-weight-bold" style="text-align: center">{{'registration.register' | translate}}</h2></div>
                <div class="col-lg-4 col-md-6 col-sm-8">
                  <h2 class="display-4 font-italic" style="text-align: center">{{'registration.register' | translate}}</h2>
                </div>
              </div>
              <div>
                <p class="lead text-center" style="margin: 0;font-weight: bold;">{{'registration.fillAccount' | translate}} </p>
                <p class="lead text-center font-italic" style="margin: 0;">{{'registration.fillAccount' | translate}}</p>
              </div>
              <hr class="my-4">
        <form>
          <div class="card">
            <h5 class="card-header text-uppercase text-center">{{'registration.generalInformation' | translate}}</h5>
            <small style="text-align: center;font-weight: bold;">{{'registration.requiredFields' | translate}}</small>
            <small style="text-align: center" class="font-italic">{{'registration.requiredFields' | translate}}</small>
            <div class="card-body">
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.employeur" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.firstName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.firstName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [attr.placeholder]="'fields.firstName' | translate" [(ngModel)]="nlmk_user.firstname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.lastName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.lastName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [placeholder]="'fields.lastName' | translate" [(ngModel)]="nlmk_user.lastname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>

              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" style="margin-top: 0px" type="date" [(ngModel)]="nlmk_user.field20_details.datenaissance" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.identityCard' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.identityCard' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.cid" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.email' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.email' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="email" [(ngModel)]="nlmk_user.email" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary" (click)="auto_form_registration_nlmk()">{{'common.validate' | translate}}</button>
          </div>
          <div class="text-center mb-2">
            {{'registration.platforms' | translate}} <a href="https://certikap.com">https://certikap.com</a> {{'common.and' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
          <div class="font-italic text-center">
            {{'registration.platforms' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>

        </form>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="show_auto_inscription_form">
          <ng-container>
            <div class="container">
              <div class="col-lg-12">
                <div class="jumbotron">
                  <div class="row justify-content-center custom-line">
                    <div class="col-lg-6 col-md-10 col-sm-9">
                      <h2 class="display-4 font-weight-bold" style="text-align: center">{{'registration.register' | translate}}</h2></div>
                    <div class="col-lg-6 col-md-9 col-sm-8">
                      <h2 class="display-4 font-italic" style="text-align: center">{{'registration.register' | translate}}</h2>
                    </div>
                  </div>
                  <div>
                    <p class="lead text-center" style="margin: 0;font-weight: bold;">{{'registration.fillAccount' | translate}} </p>
                  </div>
                  <div>
                    <p class="lead text-center font-italic" style="margin: 0;">{{'registration.fillAccount' | translate}}</p>
                  </div>
                  <hr class="my-4">
            <div class="card">
              <h5 class="card-header text-uppercase text-center">{{'registration.generalInformation' | translate}}</h5>
              <h5 class="card-header text-uppercase text-center font-italic">{{'registration.generalInformation' | translate}}</h5>
              <small style="text-align: center;font-weight: bold;">{{'registration.requiredFields' | translate}}</small>
              <small class="font-italic" style="text-align: center;">{{'registration.requiredFields' | translate}}</small>
              <div class="card-body">

                <div class="form-group row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.lastName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.lastNameRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [formControl]="lastname">
                  </div>
                </div>
                <div class="form-group row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.firstNameRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.firstNameRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [formControl]="firstname">
                  </div>
                </div>
                <div class="form-group row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.usernameRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.usernameRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [formControl]="login">
                  </div>
                </div>
                <div class="form-group row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.password' | translate}} *
                          <i class="bx bx-info-circle"
                             (mouseenter)="showInfo = true"
                             (mouseleave)="showInfo = false">
                          </i>
                          <div class="info-tooltip" *ngIf="showInfo">
                            {{'auth.passwordRules' | translate}}
                          </div>
                        </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.passwordRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="password" [formControl]="password" >
                  </div>
                  <p *ngIf="isPasswordInvalid" class="text-danger fw-bold ml-2 mt-2">
                    {{'auth.passwordRules' | translate}}
                  </p>
                </div>
                <div class="form-group row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.confirmPasswordRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.confirmPasswordRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="password" [formControl]="confirm_password" >
                  </div>
                </div>

                <div class="form-group row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.emailRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.emailRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="email" [formControl]="email">
                  </div>
                </div>
                <ng-container *ngIf="content_form && content_form.length > 0">
                  <div class="form-group row" *ngFor="let f of content_form">
                    <div class='col-md-5'>
                      <div class="row">
                        <div class='col-md-12'>
                          <label class="font-weight-bold" style="margin-bottom: 0">{{f.name}} <span *ngIf="f.is_required && f.is_required === 1">*</span></label>
                        </div>
                        <div class='col-md-12'>
                          <label class="font-italic" style="margin-bottom: 0">{{f.translation}} <span *ngIf="f.is_required && f.is_required === 1">*</span></label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-7">
                      <input class="form-control" type="{{f.inputType}}" id="{{f.ng_model_name}}" [required]="f.is_required === '1' ? '' : null">
                    </div>
                  </div>

                </ng-container>

              </div>
              <div class="form-group row">
                <div class="col-md-5 col-form-label"></div>
                <div class="col-md-7">
                  <button type="button" class="btn btn-primary" (click)="auto_form_registration_other()">{{'common.validate' | translate}}</button>
                </div>
              </div>

            </div>
                  <div class="text-center mb-2">
                    {{'registration.platforms' | translate}} <a href="https://certikap.com">https://certikap.com</a> {{'common.and' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
                  </div>
                  <div class="font-italic text-center">
                    {{'registration.platforms' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
                  </div>
            </div>
            </div>
            </div>
          </ng-container>
      </ng-container>
<ng-container *ngIf="show_auto_inscription_form_BASF">
  <div class="container">
    <div class="col-lg-12">
      <div class="jumbotron">
        <div class="title">
          <h2 class="display-4 font-weight-bold" style="text-align: center">{{forms.title}}</h2></div>
        <div><h2 class="" style="text-align: center">{{forms.label}}</h2></div>
        <div class="row justify-content-center custom-line">
          <div class="col-lg-6 col-md-10 col-sm-9">
            <h2 class="display-4 font-weight-bold" style="text-align: center">{{'registration.register' | translate}}</h2></div>
          <div class="col-lg-4 col-md-6 col-sm-8">
            <h2 class="display-4 font-italic" style="text-align: center">{{'registration.register' | translate}}</h2>
          </div>
        </div>
        <div>
          <p class="lead text-center" style="margin: 0;font-weight: bold;">{{'registration.fillAccount' | translate}} </p>
          <p class="lead text-center font-italic" style="margin: 0;">{{'registration.fillAccount' | translate}}</p>
        </div>
        <hr class="my-4">
        <form>
          <div class="card">
            <h5 class="card-header text-uppercase text-center">{{'registration.generalInformation' | translate}}</h5>
            <small style="text-align: center;font-weight: bold;">{{'registration.requiredFields' | translate}}</small>
            <small style="text-align: center" class="font-italic">{{'registration.requiredFields' | translate}}</small>
            <div class="card-body">
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.employeur" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.firstName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.firstName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [attr.placeholder]="'fields.firstName' | translate" [(ngModel)]="nlmk_user.firstname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.lastName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.lastName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [placeholder]="'fields.lastName' | translate" [(ngModel)]="nlmk_user.lastname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" style="margin-top: 0px" type="date" [(ngModel)]="nlmk_user.field20_details.datenaissance" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.emailRequired' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.email' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="email" [(ngModel)]="nlmk_user.email" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.manageremail" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary" (click)="auto_form_registration_basf()">{{'common.validate' | translate}}</button>
          </div>
          <div class="text-center mb-2">
            {{'registration.platforms' | translate}} <a href="https://certikap.com">https://certikap.com</a> {{'common.and' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
          <div class="font-italic text-center">
            {{'registration.platforms' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>
<!--form for home security-->
<ng-container *ngIf="show_form_home_security">
  <div class="container">
    <div class="col-lg-12">
      <div class="jumbotron">
        <div class="title">
          <h2 class="display-4 font-weight-bold" style="text-align: center">{{forms.title}}</h2></div>
        <div class="row justify-content-center custom-line">
          <div class="col-lg-6 col-md-10 col-sm-9">
            <h2 class="display-4 font-weight-bold" style="text-align: center">{{'registration.register' | translate}}</h2></div>
          <div class="col-lg-4 col-md-6 col-sm-8">
            <h2 class="display-4 font-italic" style="text-align: center">{{'registration.register' | translate}}</h2>
          </div>
        </div>
        <div>
          <p class="lead text-center" style="margin: 0;font-weight: bold;">{{'registration.fillAccount' | translate}} </p>
          <p class="lead text-center font-italic" style="margin: 0;">{{'registration.fillAccount' | translate}}</p>
        </div>
        <hr class="my-4">
        <form>
          <div class="card">
            <h5 class="card-header text-uppercase text-center">{{'registration.generalInformation' | translate}}</h5>
            <small style="text-align: center;font-weight: bold;">{{'registration.requiredFields' | translate}}</small>
            <small style="text-align: center" class="font-italic">{{'registration.requiredFields' | translate}}</small>
            <div class="card-body">
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.employeur" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.firstName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.firstName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [attr.placeholder]="'fields.firstName' | translate" [(ngModel)]="nlmk_user.firstname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.lastName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.lastName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [placeholder]="'fields.lastName' | translate" [(ngModel)]="nlmk_user.lastname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" style="margin-top: 0px" type="date" [(ngModel)]="nlmk_user.field20_details.datenaissance" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.emailRequired' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.email' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="email" [(ngModel)]="nlmk_user.email" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.manageremail" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary" (click)="auto_form_registration_basf()">{{'common.validate' | translate}}</button>
          </div>
          <div class="text-center mb-2">
            {{'registration.platforms' | translate}} <a href="https://certikap.com">https://certikap.com</a> {{'common.and' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
          <div class="font-italic text-center">
            {{'registration.platforms' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>



<!--Formulaire ORIL 1- Accueil Sécurité ORIL-->
<ng-container *ngIf="show_auto_inscription_form_ORIL_FR">
  <div class="container">
    <div class="col-lg-12">
      <div class="jumbotron">
        <div class="title">
          <h2 class="display-4 font-weight-bold" style="text-align: center">{{forms.title}}</h2></div>
        <div class="row justify-content-center custom-line">
          <div class="col-lg-6 col-md-10 col-sm-9">
            <h2 class="display-4 font-weight-bold" style="text-align: center">{{'registration.register' | translate}}</h2></div>
          <div class="col-lg-4 col-md-6 col-sm-8">
            <h2 class="display-4 font-italic" style="text-align: center">{{'registration.register' | translate}}</h2>
          </div>
        </div>
        <div>
          <p class="lead text-center" style="margin: 0;font-weight: bold;">{{'registration.fillAccount' | translate}} </p>
          <p class="lead text-center font-italic" style="margin: 0;">{{'registration.fillAccount' | translate}}</p>
        </div>
        <hr class="my-4">
        <form>
          <div class="card">
            <h5 class="card-header text-uppercase text-center">{{'registration.generalInformation' | translate}}</h5>
            <small style="text-align: center;font-weight: bold;">{{'registration.requiredFields' | translate}}</small>
            <small style="text-align: center" class="font-italic">{{'registration.requiredFields' | translate}}</small>
            <div class="card-body">
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.employeur" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.firstName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.firstName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [attr.placeholder]="'fields.firstName' | translate" [(ngModel)]="nlmk_user.firstname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.lastName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.lastName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [placeholder]="'fields.lastName' | translate" [(ngModel)]="nlmk_user.lastname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" style="margin-top: 0px" type="date" [(ngModel)]="nlmk_user.field20_details.datenaissance" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.emailRequired' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.email' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="email" [(ngModel)]="nlmk_user.email" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.manageremail" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary" (click)="auto_form_registration_ORIL_FR()">{{'common.validate' | translate}}</button>
          </div>
          <div class="text-center mb-2">
            {{'registration.platforms' | translate}} <a href="https://certikap.com">https://certikap.com</a> {{'common.and' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
          <div class="font-italic text-center">
            {{'registration.platforms' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>

<!--Formulaire ORIL 2- Safety Instructions ORIL-->

<ng-container *ngIf="show_auto_inscription_form_ORIL_EN">
  <div class="container">
    <div class="col-lg-12">
      <div class="jumbotron">
        <div class="title">
          <h2 class="display-4 font-weight-bold" style="text-align: center">{{forms.title}}</h2></div>
        <div class="row justify-content-center custom-line">
          <div class="col-lg-6 col-md-10 col-sm-9">
            <h2 class="display-4 font-weight-bold" style="text-align: center">{{'registration.register' | translate}}</h2></div>
          <div class="col-lg-4 col-md-6 col-sm-8">
            <h2 class="display-4 font-italic" style="text-align: center">{{'registration.register' | translate}}</h2>
          </div>
        </div>
        <div>
          <p class="lead text-center" style="margin: 0;font-weight: bold;">{{'registration.fillAccount' | translate}} </p>
          <p class="lead text-center font-italic" style="margin: 0;">{{'registration.fillAccount' | translate}}</p>
        </div>
        <hr class="my-4">
        <form>
          <div class="card">
            <h5 class="card-header text-uppercase text-center">{{'registration.generalInformation' | translate}}</h5>
            <small style="text-align: center;font-weight: bold;">{{'registration.requiredFields' | translate}}</small>
            <small style="text-align: center" class="font-italic">{{'registration.requiredFields' | translate}}</small>
            <div class="card-body">
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.employeur" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.firstName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.firstName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [attr.placeholder]="'fields.firstName' | translate" [(ngModel)]="nlmk_user.firstname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.lastName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.lastName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [placeholder]="'fields.lastName' | translate" [(ngModel)]="nlmk_user.lastname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" style="margin-top: 0px" type="date" [(ngModel)]="nlmk_user.field20_details.datenaissance" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.emailRequired' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.email' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="email" [(ngModel)]="nlmk_user.email" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.manageremail" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary" (click)="auto_form_registration_ORIL_EN()">{{'common.validate' | translate}}</button>
          </div>
          <div class="text-center mb-2">
            {{'registration.platforms' | translate}} <a href="https://certikap.com">https://certikap.com</a> {{'common.and' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
          <div class="font-italic text-center">
            {{'registration.platforms' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>

<!--Formulaire CEA PARIS-SACLAY- AS Saclay-->

<ng-container *ngIf="show_form_AS_SACLAY">
  <div class="container">
    <div class="col-lg-12">
      <div class="jumbotron" style="padding-top: 3rem;">
        <div class="title mb-4">
          <h2 class="h2 font-weight-bold text-center">{{forms.title}}</h2>
        </div>

        <div class="container mb-4">
            <h1 class="h1 font-weight-bold text-center" style="font-size: 4em;margin-bottom: 0px;">{{'registration.createOrReactivate' | translate}}</h1>
            <h1 class="h1 font-italic text-center">{{'registration.createOrReactivate' | translate}}</h1>
        </div>

        <div>
          <p class="text-center font-weight-bold" style="margin: 0;">{{'registration.fillFields' | translate}}</p>
          <p class="text-center font-italic" style="margin: 0;">{{'registration.fillFields' | translate}}</p>
        </div>


        <hr class="my-4">
        <form>
          <div class="card">
            <h5 class="card-header text-uppercase text-center">{{'registration.generalInformation' | translate}}</h5>
            <small style="text-align: center;font-weight: bold;">{{'registration.requiredFields' | translate}}</small>
            <small style="text-align: center" class="font-italic">{{'registration.requiredFields' | translate}}</small>
            <div class="card-body">
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.lastName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.lastNameRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [placeholder]="'fields.lastName' | translate" [(ngModel)]="nlmk_user.lastname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.firstName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.firstNameRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [attr.placeholder]="'fields.firstName' | translate" [(ngModel)]="nlmk_user.firstname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.birthDate' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" style="margin-top: 0px" type="date" [(ngModel)]="nlmk_user.field20_details.datenaissance" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.emailRequired' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.emailRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="email" [(ngModel)]="nlmk_user.email" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.unit' | translate}}</label>
                        <label class="element-avec-bulle">
                        <i  class="fas fa-info-circle"
                           (mouseenter)="afficherInfoBulle = true"
                           (mouseleave)="afficherInfoBulle = false">
                        </i>
                        <div class="bulle-info" *ngIf="afficherInfoBulle">
                          {{'registration.unitHint' | translate}}</div>
                      </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.unit' | translate}}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.service" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.companyRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.employeur" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.manageremail" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.facilityNumber' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.facilityNumber' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.numero_installation" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary" (click)="form_AS_SACLAY()">{{'common.validate' | translate}}</button>
          </div>
          <div class="text-center mb-2">
            {{'registration.platforms' | translate}} <a href="https://certikap.com">https://certikap.com</a> {{'common.and' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
          <div class="font-italic text-center">
            {{'registration.platforms' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>

<!--Formulaire CEA PARIS-SACLAY- AS FONTENAY-->

<ng-container *ngIf="show_form_AS_FONTENAY">
  <div class="container">
    <div class="col-lg-12">
      <div class="jumbotron" style="padding-top: 3rem;">
        <div class="title mb-4">
          <h2 class="h2 font-weight-bold text-center">{{forms.title}}</h2>
        </div>

        <div class="container mb-4">
          <h1 class="h1 font-weight-bold text-center" style="font-size: 4em;margin-bottom: 0px;">{{'registration.createOrReactivate' | translate}}</h1>
          <h1 class="h1 font-italic text-center">{{'registration.createOrReactivate' | translate}}</h1>
        </div>

        <div>
          <p class="text-center font-weight-bold" style="margin: 0;">{{'registration.fillFields' | translate}}</p>
          <p class="text-center font-italic" style="margin: 0;">{{'registration.fillFields' | translate}}</p>
        </div>
        <hr class="my-4">
        <form>
          <div class="card">
            <h5 class="card-header text-uppercase text-center">{{'registration.generalInformation' | translate}}</h5>
            <small style="text-align: center;font-weight: bold;">{{'registration.requiredFields' | translate}}</small>
            <small style="text-align: center" class="font-italic">{{'registration.requiredFields' | translate}}</small>
            <div class="card-body">
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.lastName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.lastNameRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [placeholder]="'fields.lastName' | translate" [(ngModel)]="nlmk_user.lastname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.firstName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.firstNameRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [attr.placeholder]="'fields.firstName' | translate" [(ngModel)]="nlmk_user.firstname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.birthDate' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" style="margin-top: 0px" type="date" [(ngModel)]="nlmk_user.field20_details.datenaissance" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.emailRequired' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.emailRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="email" [(ngModel)]="nlmk_user.email" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.unit' | translate}}</label>
                        <label class="element-avec-bulle">
                          <i  class="fas fa-info-circle"
                              (mouseenter)="afficherInfoBulle = true"
                              (mouseleave)="afficherInfoBulle = false">
                          </i>
                          <div class="bulle-info" *ngIf="afficherInfoBulle">
                            {{'registration.unitHint' | translate}}</div>
                        </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.unit' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.service" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.companyRequired' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.employeur" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.manageremail" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.facilityNumber' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.facilityNumber' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.numero_installation" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary" (click)="form_AS_FONTENAY()">{{'common.validate' | translate}}</button>
          </div>
          <div class="text-center mb-2">
            {{'registration.platforms' | translate}} <a href="https://certikap.com">https://certikap.com</a> {{'common.and' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
          <div class="font-italic text-center">
            {{'registration.platforms' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="show_auto_inscription_form_Forgital">
  <div class="container">
    <div class="col-lg-12">
      <div class="jumbotron">
        <div class="title">
          <h2 class="display-4 font-weight-bold" style="text-align: center">{{forms.title}}</h2></div>
        <div><h2 class="" style="text-align: center">{{forms.label}}</h2></div>
        <div class="row justify-content-center custom-line">
          <div class="col-lg-6 col-md-10 col-sm-9">
            <h2 class="display-4 font-weight-bold" style="text-align: center">{{'registration.register' | translate}}</h2></div>
          <div class="col-lg-4 col-md-6 col-sm-8">
            <h2 class="display-4 font-italic" style="text-align: center">{{'registration.register' | translate}}</h2>
          </div>
        </div>
        <div>
          <p class="lead text-center" style="margin: 0;font-weight: bold;">{{'registration.fillAccount' | translate}} </p>
          <p class="lead text-center font-italic" style="margin: 0;">{{'registration.fillAccount' | translate}}</p>
        </div>
        <hr class="my-4">
        <form>
          <div class="card">
            <h5 class="card-header text-uppercase text-center">{{'registration.generalInformation' | translate}}</h5>
            <small style="text-align: center;font-weight: bold;">{{'registration.requiredFields' | translate}}</small>
            <small style="text-align: center" class="font-italic">{{'registration.requiredFields' | translate}}</small>
            <div class="card-body">
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.employeur" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.firstName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.firstName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [attr.placeholder]="'fields.firstName' | translate" [(ngModel)]="nlmk_user.firstname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.lastName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.lastName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [placeholder]="'fields.lastName' | translate" [(ngModel)]="nlmk_user.lastname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" style="margin-top: 0px" type="date" [(ngModel)]="nlmk_user.field20_details.datenaissance" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.emailRequired' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.email' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="email" [(ngModel)]="nlmk_user.email" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.manageremail" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary" (click)="auto_form_registration_Forgital()">{{'common.validate' | translate}}</button>
          </div>
          <div class="text-center mb-2">
            {{'registration.platforms' | translate}} <a href="https://certikap.com">https://certikap.com</a> {{'common.and' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
          <div class="font-italic text-center">
            {{'registration.platforms' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="show_auto_inscription_form_BASF_Lyon">
  <div class="container">
    <div class="col-lg-12">
      <div class="jumbotron">
        <div class="title">
          <h2 class="display-4 font-weight-bold" style="text-align: center">{{forms.title}}</h2></div>
        <div><h2 class="" style="text-align: center">{{forms.label}}</h2></div>
        <div class="row justify-content-center custom-line">
          <div class="col-lg-6 col-md-10 col-sm-9">
            <h2 class="display-4 font-weight-bold" style="text-align: center">{{'registration.register' | translate}}</h2></div>
          <div class="col-lg-4 col-md-6 col-sm-8">
            <h2 class="display-4 font-italic" style="text-align: center">{{'registration.register' | translate}}</h2>
          </div>
        </div>
        <div>
          <p class="lead text-center" style="margin: 0;font-weight: bold;">{{'registration.fillAccount' | translate}} </p>
          <p class="lead text-center font-italic" style="margin: 0;">{{'registration.fillAccount' | translate}}</p>
        </div>
        <hr class="my-4">
        <form>
          <div class="card">
            <h5 class="card-header text-uppercase text-center">{{'registration.generalInformation' | translate}}</h5>
            <small style="text-align: center;font-weight: bold;">{{'registration.requiredFields' | translate}}</small>
            <small style="text-align: center" class="font-italic">{{'registration.requiredFields' | translate}}</small>
            <div class="card-body">
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.employeur" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.firstName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.firstName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [attr.placeholder]="'fields.firstName' | translate" [(ngModel)]="nlmk_user.firstname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.lastName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.lastName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [placeholder]="'fields.lastName' | translate" [(ngModel)]="nlmk_user.lastname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" style="margin-top: 0px" type="date" [(ngModel)]="nlmk_user.field20_details.datenaissance" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.emailRequired' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.email' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="email" [(ngModel)]="nlmk_user.email" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.manageremail" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary" (click)="auto_form_registration_basf_lyon()">{{'common.validate' | translate}}</button>
          </div>
          <div class="text-center mb-2">
            {{'registration.platforms' | translate}} <a href="https://certikap.com">https://certikap.com</a> {{'common.and' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
          <div class="font-italic text-center">
            {{'registration.platforms' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="show_auto_inscription_form_LVMH">
  <div class="container">
    <div class="col-lg-12">
      <div class="jumbotron">
        <div class="title">
          <h2 class="display-4 font-weight-bold" style="text-align: center">{{forms.title}}</h2></div>
        <div><h2 class="" style="text-align: center">{{forms.label}}</h2></div>
        <div class="row justify-content-center custom-line">
          <div class="col-lg-6 col-md-10 col-sm-9">
            <h2 class="display-4 font-weight-bold" style="text-align: center">{{'registration.register' | translate}}</h2></div>
          <div class="col-lg-4 col-md-6 col-sm-8">
            <h2 class="display-4 font-italic" style="text-align: center">{{'registration.register' | translate}}</h2>
          </div>
        </div>
        <div>
          <p class="lead text-center" style="margin: 0;font-weight: bold;">{{'registration.fillAccount' | translate}} </p>
          <p class="lead text-center font-italic" style="margin: 0;">{{'registration.fillAccount' | translate}}</p>
        </div>
        <hr class="my-4">
        <form>
          <div class="card">
            <h5 class="card-header text-uppercase text-center">{{'registration.generalInformation' | translate}}</h5>
            <small style="text-align: center;font-weight: bold;">{{'registration.requiredFields' | translate}}</small>
            <small style="text-align: center" class="font-italic">{{'registration.requiredFields' | translate}}</small>
            <div class="card-body">
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.companyRequired' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.employeur" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.firstName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.firstName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [attr.placeholder]="'fields.firstName' | translate" [(ngModel)]="nlmk_user.firstname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.lastName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.lastName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [placeholder]="'fields.lastName' | translate" [(ngModel)]="nlmk_user.lastname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" style="margin-top: 0px" type="date" [(ngModel)]="nlmk_user.field20_details.datenaissance" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.emailRequired' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.email' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="email" [(ngModel)]="nlmk_user.email" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.managerEmail' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [(ngModel)]="nlmk_user.field20_details.manageremail" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary" (click)="auto_form_registration_lvmh()">{{'common.validate' | translate}}</button>
          </div>
          <div class="text-center mb-2">
            {{'registration.platforms' | translate}} <a href="https://certikap.com">https://certikap.com</a> {{'common.and' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
          <div class="font-italic text-center">
            {{'registration.platforms' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.com</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="show_auto_inscription_form_PIMENT">
  <div class="container">
    <div class="col-lg-12">
      <div class="jumbotron">
        <div class="title">
          <h2 class="display-4 font-weight-bold" style="text-align: center">{{forms.title}}</h2></div>
        <div><h2 class="" style="text-align: center">{{forms.label}}</h2></div>
        <div class="row justify-content-center custom-line">
          <div class="col-lg-6 col-md-10 col-sm-9">
            <h2 class="display-4 font-weight-bold" style="text-align: center">{{'registration.register' | translate}}</h2></div>
          <div class="col-lg-4 col-md-6 col-sm-8">
            <h2 class="display-4 font-italic" style="text-align: center">{{'registration.register' | translate}}</h2>
          </div>
        </div>
        <div>
          <p class="lead text-center" style="margin: 0;font-weight: bold;">{{'registration.fillAccount' | translate}} </p>
          <p class="lead text-center font-italic" style="margin: 0;">{{'registration.fillAccount' | translate}}</p>
        </div>
        <hr class="my-4">
        <form>
          <div class="card">
            <h5 class="card-header text-uppercase text-center">{{'registration.generalInformation' | translate}}</h5>
            <small style="text-align: center;font-weight: bold;">{{'registration.requiredFields' | translate}}</small>
            <small style="text-align: center" class="font-italic">{{'registration.requiredFields' | translate}}</small>
            <div class="card-body">
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.firstName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.firstName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [attr.placeholder]="'fields.firstName' | translate" [(ngModel)]="nlmk_user.firstname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.lastName' | translate}} * </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.lastName' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="text" [placeholder]="'fields.lastName' | translate" [(ngModel)]="nlmk_user.lastname" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'fields.birthDate' | translate}} </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" style="margin-top: 0px" type="date" [(ngModel)]="nlmk_user.field20_details.datenaissance" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="container-fluid" style="padding: 10px">
                <div class="row">
                  <div class='col-md-5'>
                    <div class="row">
                      <div class='col-md-12'>
                        <label class="font-weight-bold" style="margin-bottom: 0">{{'registration.emailRequired' | translate}}</label>
                      </div>
                      <div class='col-md-12'>
                        <label class="font-italic" style="margin-bottom: 0">{{'registration.email' | translate}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7">
                    <input class="form-control" type="email" [(ngModel)]="nlmk_user.email" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
            <button type="button" class="btn btn-primary" (click)="auto_form_registration_piment()">{{'common.validate' | translate}}</button>
          </div>
          <div class="text-center mb-2">
            {{'registration.platforms' | translate}} <a href="https://certikap.com">https://certikap.com</a> {{'common.and' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.net</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
          <div class="font-italic text-center">
            {{'registration.platforms' | translate}} <a href="https://kaptitude.elmg.net/">kaptitude.elmg.net</a> {{'registration.privacyNotice' | translate}} <a href="mailto:formateur@kaptitude.com">formateur&#64;kaptitude.com</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>

<app-footer></app-footer>
